import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/a11y';
import { A11y, Autoplay, Navigation } from 'swiper/modules';

class HistoriaSection {
    constructor(component) {
        const slider = component.querySelector('[data-history-slider]');

        if (!slider || slider.swiper) {
            return;
        }

        const count = slider.querySelectorAll('.swiper-slide').length;
        const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        const swiper = new Swiper(slider, {
            modules: [A11y, Autoplay, Navigation],
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 24,
            autoHeight: true,
            watchOverflow: true,
            speed: motion.matches ? 0 : 300,
            autoplay: count > 1 && !motion.matches
                ? {
                    delay: 10000,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true,
                }
                : false,
            navigation: {
                nextEl: component.querySelector('.swiper-button-next'),
                prevEl: component.querySelector('.swiper-button-prev'),
            },
            a11y: {
                prevSlideMessage: 'Marco anterior',
                nextSlideMessage: 'Próximo marco',
                slideLabelMessage: '{{index}} de {{slidesLength}}',
            },
        });

        const update = () => {
            swiper.update();
            swiper.updateAutoHeight(0);
        };

        component.querySelectorAll('img').forEach((image) => {
            image.addEventListener('load', update);
            image.addEventListener('error', update);
        });

        if (document.fonts) {
            document.fonts.ready.then(update);
        }

        component.addEventListener('focusin', () => {
            swiper.autoplay.stop();
        });

        motion.addEventListener('change', () => {
            swiper.params.speed = motion.matches ? 0 : 300;

            if (motion.matches) {
                swiper.autoplay.stop();
            }
        });
    }
}

document.querySelectorAll('[data-module="historia_section"]').forEach(
    (component) => new HistoriaSection(component)
);

export default HistoriaSection;
